import { RouteObject } from "react-router";

export const FinancingRoutes: RouteObject[] = [
  {
    path: "finance_option/:financeOptionId",
    loader: () => null,
    async lazy() {
      const { EditFinanceOptionModal } = await import(
        /* webpackChunkName: "orgs-cache-finance-option-id" */ "orgs/Configuration/FinancingTab/FinanceOptions/EditFinanceOptionModal"
      );
      return { element: <EditFinanceOptionModal /> };
    },
  },
  {
    path: "discount/:discountId",
    loader: () => null,
    async lazy() {
      const { EditDiscountModal } = await import(
        /* webpackChunkName: "orgs-cache-discount-id" */ "orgs/Configuration/FinancingTab/Discounts/EditDiscountModal"
      );
      return { element: <EditDiscountModal /> };
    },
  },
  {
    path: "payment_term/:paymentTermId",
    loader: () => null,
    async lazy() {
      const { EditPaymentTermModal } = await import(
        /* webpackChunkName: "orgs-cache-payment-term-id" */ "orgs/Configuration/FinancingTab/PaymentTerms/EditPaymentTermModal"
      );
      return { element: <EditPaymentTermModal /> };
    },
  },
  {
    path: "slides/:slideIndex",
    async loader(args) {
      const { slideModalLoader } = await import(
        /* webpackChunkName: "orgs-cache-slide-modal-loader" */ "src/router/loaders/orgs/Financing"
      );
      return slideModalLoader(args);
    },
    async lazy() {
      const { SlideModal } = await import(
        /* webpackChunkName: "orgs-cache-slide-modal" */ "orgs/Configuration/FinancingTab/EnhancedPricePresentation/SlideModal"
      );
      return { element: <SlideModal /> };
    },
  },
];
